import {useState, useLayoutEffect, useCallback, RefObject} from 'react';
import debounce from 'lodash.debounce';

export const useIsOverflow = (ref?: RefObject<HTMLElement>): {isOverflow: boolean; calculateOverflow: () => void} => {
    const [isOverflow, setIsOverflow] = useState(false);
    const threshold = 5;

    const calculateOverflow = useCallback(() => {
        if (ref && ref.current) {
            const {current} = ref;
            const navigationHeight = 125;
            const hasElementOverflow = current.scrollHeight + navigationHeight > window.innerHeight + threshold;
            setIsOverflow(hasElementOverflow);
        } else {
            const hasGeneralOverflow = window.innerHeight < 60 + document.body.clientHeight + threshold;
            setIsOverflow(hasGeneralOverflow);
        }
    }, [ref]);

    useLayoutEffect(() => {
        const trigger = debounce(() => {
            calculateOverflow();
        }, 100);

        window.addEventListener('resize', trigger);
        trigger();

        return () => {
            window.removeEventListener('resize', trigger);
            trigger.cancel();
        };
    }, [calculateOverflow]);

    return {isOverflow, calculateOverflow};
};
